module.exports = __webpack_public_path__ + "img/downAppCode3.7b338846.png";